export function bannerIsActive(start, end, now = Date.now()) {
  const begins = start ? Date.parse(start) : -Infinity;
  const expires = end ? Date.parse(end) : Infinity;
  return !Number.isNaN(begins) && !Number.isNaN(expires) && begins < expires && now >= begins && now < expires;
}
if (typeof customElements !== 'undefined' && !customElements.get('jd-collection-banner')) {
  customElements.define('jd-collection-banner', class extends HTMLElement {
    connectedCallback() {
      this.refresh = () => {
        this.hidden = !bannerIsActive(this.dataset.start || '', this.dataset.end || '');
      };
      this.refresh();
      this.timer = setInterval(this.refresh, 1000);
      this.onVisible = () => { if (!document.hidden) this.refresh(); };
      document.addEventListener('visibilitychange', this.onVisible);
      window.addEventListener('pageshow', this.refresh);
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.onVisible);
      window.removeEventListener('pageshow', this.refresh);
    }
  });
}
